<script setup>
import { ref, computed } from "vue";

const props = defineProps({
  vehicle: {
    type: Object,
    default: null,
  },
  open: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:open", "submit"]);

const remarks = ref("");
const remarksError = ref("");

const innerOpen = computed({
  get() {
    return props.open;
  },
  set(val) {
    emit("update:open", val);
  },
});

function onCancel() {
  remarks.value = "";
  remarksError.value = "";
  innerOpen.value = false;
}

function onSubmit() {
  remarksError.value = "";
  if (!remarks.value || remarks.value.trim().length < 5) {
    remarksError.value = "Please provide a reason of at least 5 characters.";
    return;
  }
  emit("submit", { vehicleId: props.vehicle?.id, remarks: remarks.value.trim() });
}

function onDialogClosed() {
  if (!props.loading) {
    onCancel();
  }
}
</script>

<template>
  <v-dialog
    v-model="innerOpen"
    max-width="520"
    persistent
    @click:outside="onDialogClosed"
  >
    <v-card>
      <!-- Header -->
      <v-card-title class="primary white--text py-3 px-4">
        <v-icon left color="white">mdi-archive-arrow-down</v-icon>
        Apply for Vehicle Archival
      </v-card-title>

      <v-card-text class="pt-5 pb-2 px-5">
        <!-- Vehicle identity chip -->
        <v-row dense class="mb-3">
          <v-col cols="12">
            <div class="caption text--secondary mb-1">Vehicle</div>
            <v-chip color="primary" outlined label>
              <v-icon left small>mdi-car</v-icon>
              {{ vehicle ? vehicle.registrationNumber : "—" }}
            </v-chip>
          </v-col>
        </v-row>

        <v-divider class="mb-4" />

        <!-- Info notice -->
        <v-alert
          type="info"
          dense
          text
          class="mb-4 body-2"
          icon="mdi-information-outline"
        >
          Your application will be reviewed by county revenue officers before
          the vehicle is archived. Please provide a clear reason below.
        </v-alert>

        <!-- Reason field -->
        <v-textarea
          v-model="remarks"
          label="Reason for Archival"
          placeholder="e.g. Vehicle sold, decommissioned, total loss, etc."
          outlined
          dense
          rows="4"
          counter="500"
          maxlength="500"
          :error-messages="remarksError"
          :disabled="loading"
          auto-grow
        />
      </v-card-text>

      <v-card-actions class="px-5 pb-4">
        <v-spacer />
        <v-btn text :disabled="loading" @click="onCancel">Cancel</v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          :disabled="loading"
          @click="onSubmit"
        >
          <v-icon left>mdi-send</v-icon>
          Submit Application
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
